import {
  Component,
  OnInit,
  AfterViewInit,
  AfterViewChecked,
  ChangeDetectorRef
} from '@angular/core';
import { Router } from '@angular/router';
import {
  FooterContentService,
  HeaderContentService
} from '@tmhcc-ng-lib/content-service';
import { DialogConfig, DialogService } from '@tmhcc-ng-lib/framwork/dialog';
import { AllowedRoutes, FooterMenu } from '@tmhcc-ng-lib/models';
import { FooterDataType } from 'libs/content-service/def/footer-content';
import { CustomModalComponent } from '../custom-modal/custom-modal.component';

@Component({
  selector: 'footer-page',
  templateUrl: './footer-page.component.html',
  styleUrls: ['./footer-page.component.scss']
})
export class FooterPageComponent implements OnInit, AfterViewChecked {
  loginPage: boolean = false;
  isDataAvailable: boolean = false;
  footerData: FooterDataType;

  modalContent: DialogConfig = {
    data: {
      para: '',
      phone: '',
      email: ''
    },
    modalSetting: {
      title: '',
      hideHeader: false,
      hideFooter: true,
      hideHeaderX: false, // header X button;
      hideSave: true,
      closeOnOutsideClick: true
    }
  };

  constructor(
    private cdr: ChangeDetectorRef,
    private footerContentService: FooterContentService,
    public dialogService: DialogService,
    public router: Router,
    private headerContentService: HeaderContentService
  ) {}

  ngOnInit() {
    this.footerContentService.data$.subscribe((res: FooterDataType) => {
      this.callFooterData(res);
    });
    this.headerContentService.data$.subscribe(res => {
      if (res) {
        this.modalContent.data = {
          para: res.data[0].description,
          phone: res.data[0].displayItems[0].description,
          email: res.data[0].displayItems[1].description
        };
        this.modalContent.modalSetting = {
          title: res.data[0].heading,
          hideFooter: true
        };
      }
    });
  }

  callFooterData(data) {
    if (data) {
      this.footerData = data;
      this.isDataAvailable = true;
    }
  }

  ngAfterViewChecked() {
    const url = window.location.href;
    this.loginPage = url.includes('login');
    this.cdr.detectChanges();
  }

  footerLink(item) {
    switch (item.keyText.toUpperCase()) {
      case FooterMenu.ContactUs:
        this.router.navigate([AllowedRoutes.ContactUs]);
        break;
      case FooterMenu.News:
        this.router.navigate([AllowedRoutes.NewsFeed]);
        break;
      default:
        location.href = item.navigation.Url;
    }
  }

  openModal() {
    this.dialogService.open(CustomModalComponent, this.modalContent);
  }
}
